
const prepareShow = file => {
  return file
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  setDoSearch (dt) {
    this.search.generic = dt
    this.setPage(1)
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/index/resources/methods.js